import React from 'react'
import halfcircle from "../../Assets/images/half-circle-shade.svg";
import applestore from "../../Assets/images/apple-store.svg";
import googlestore from "../../Assets/images/google-store.svg";
import splashimage from "../../Assets/images/splash-img.png";
import { Link } from 'react-router-dom';
import { LanguageConstants } from '../../constants/LanguageConstants';

function Download() {
  return (
    <>
    <section className="download-app-sec">
    <div className="container">
      <div className="download-app-inner">
        <img className="circle-img" src={halfcircle}  alt=""/>
        <img className="circle-img-mob d-block d-md-none" src={halfcircle}  alt=""/>
        <div className="download-position">
          <div className="row">
            <div className="col-md-6">
              <h3 className="download-heading">{LanguageConstants?.DOWNLADAPP}</h3>
              <p className="com-para">Lorem Ipsum&nbsp;is simply dummy text of the printing and typesettiny text of the printing and typesetting industry. Lorem Ipsum has been the industry's standard dummy </p>
              <div className="app-btns">
                <a href='https://www.apple.com/in/app-store/' target='_blanck' className="single-app-btn"><img src={applestore}  alt=""/></a>
                <a href='https://play.google.com/store/apps?hl=en_IN' target='_blanck' className="single-app-btn"><img src={googlestore}  alt=""/></a>
              </div>
            </div>
          </div>
          <img className="splash-img" src={splashimage}  alt=""/>
        </div>
      </div>
    </div>
  </section>
    </>
  )
}

export default Download